import { MessageCircle } from "lucide-react";
import { WHATSAPP_NUMBER } from "@/lib/cart";
import { track } from "@/lib/analytics";

const WA_GREETING = encodeURIComponent(
  "Hello Annapurna Home Pickles, I would like to place an order."
);

export const WhatsAppFloat = () => {
  return (
    <a
      data-testid="whatsapp-float-button"
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WA_GREETING}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Order on WhatsApp"
      onClick={() => track("whatsapp_contact_clicked", { source: "floating_button" })}
      className="fixed bottom-6 left-6 z-30 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] hover:bg-[#128C7E] text-white grid place-items-center shadow-2xl transition-all hover:scale-110"
    >
      <MessageCircle className="w-7 h-7 sm:w-8 sm:h-8" />
      <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#F5E6CC] border-2 border-[#25D366] rounded-full animate-pulse" />
    </a>
  );
};
